module.exports = __webpack_public_path__ + "static/assets/1ff17b9888a5ea71d95c8f03b03dbcb4.svg";